module.exports = __webpack_public_path__ + "img/hexa_logo_preto.3adb4542.png";